import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createStudentBadge } from '@services/registry';

export function useCreateStudentBadge({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ title, year, branchId }) => {
            if (!branchId) throw new Error('Campus is required');
            return await createStudentBadge({ tenantId, branchId, title, year });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['students', tenantId] });
        },
    });
}
